import { DomainError } from '../shared/DomainError';
import type { DailyStep } from './models';
import type { DailyStepId } from '../shared/ids';

export class ReorderingError extends DomainError {
  public constructor(code: string, message: string) {
    super(code, message);
    this.name = 'ReorderingError';
  }
}

export function reorderDailySteps(
  steps: readonly DailyStep[],
  orderedIds: readonly DailyStepId[],
  updatedAt: string,
): readonly DailyStep[] {
  if (orderedIds.length !== steps.length) {
    throw new ReorderingError('reorder_incomplete', 'Toutes les missions doivent être ordonnées.');
  }
  if (new Set(orderedIds).size !== orderedIds.length) {
    throw new ReorderingError('reorder_duplicate_id', 'Une mission apparaît plusieurs fois.');
  }
  const byId = new Map(steps.map((step) => [step.id, step]));
  return orderedIds.map((id, order) => {
    const step = byId.get(id);
    if (!step) throw new ReorderingError('reorder_unknown_id', 'Une mission est inconnue.');
    return { ...step, order, updatedAt };
  });
}
